import { baseApi } from "common/redux/core/api.base";
import { ApiCacheTags } from "common/models/api-base.model";
import { ConfigurationHubService } from "../../services/configuration-hub.service";
import {
  TagLibraryApiResponse,
  TagEnrichmentApiResponse,
  TagEnrichmentApiRequest,
  TagLibraryConfig
} from "../../models/configuration-hub.model";

const tagLibraryApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllTagLibraryConfigurations: build.query<TagLibraryApiResponse, void>({
      queryFn: () => {
        return ConfigurationHubService.getAllTagLibraryConfigurations();
      },
      providesTags: [ApiCacheTags.TAG_LIBRARY_CONFIGURATIONS]
    }),

    deleteTagLibraryConfiguration: build.mutation<void, string>({
      queryFn: (guidCode: string) => {
        return ConfigurationHubService.deleteTagLibraryConfiguration(guidCode);
      },
      invalidatesTags: [ApiCacheTags.TAG_LIBRARY_CONFIGURATIONS]
    }),

    getTagEnrichmentDetails: build.query<
      TagEnrichmentApiResponse,
      TagEnrichmentApiRequest
    >({
      queryFn: ({ CFIHOSMasterObjectId, isActive }) => {
        return ConfigurationHubService.getTagEnrichmentDetails(
          CFIHOSMasterObjectId,
          isActive
        );
      },
      providesTags: [ApiCacheTags.TAG_LIBRARY_CONFIGURATIONS]
    }),

    getTagConfigCardUpdate: build.query<TagLibraryConfig, string>({
      queryFn: (guidCode: string) => {
        return ConfigurationHubService.getTagConfigCardUpdate(guidCode);
      },
      providesTags: [ApiCacheTags.TAG_LIBRARY_CONFIGURATIONS]
    })
  })
});

export const {
  useGetAllTagLibraryConfigurationsQuery,
  useDeleteTagLibraryConfigurationMutation,
  useGetTagEnrichmentDetailsQuery,
  useGetTagConfigCardUpdateQuery
} = tagLibraryApi;

export { tagLibraryApi };
